import {Component} from '@angular/core';
import { NavigationService } from '../services/navigation.service';



@Component({
  selector: 'error-page',
  templateUrl: './error-page.component.html',
  styles: []
})




export class ErrorPageComponent {


  constructor(
    private navigationService: NavigationService,
  ) {}

  goToProposedInsuredAuthPage() {
    this.navigationService.nextSectionRelative('find-application');
  }

  goToProducerAuthPage() {
    this.navigationService.nextSectionRelative('welcome');
  }

}
